import { Pagination } from 'react-admin'
import React from 'react'

const DefaultPagination = ({ ...props }) => {
  return <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
}

export default DefaultPagination
